// @ts-nocheck
import React, { FC, useMemo } from "react";
import { Field, FormRenderProps } from "react-final-form";
import Typography from "@material-ui/core/Typography";
import { Theme } from "@material-ui/core/styles";
import { makeStyles } from "@material-ui/core";
import { getData } from "country-list";
import BootstrapInput from "../../../../../components/BootstrapInput";
import Autocomplete from "../../../../../components/Autocomplete";
import IconButton from "../../../../../components/IconButton";
import FontIcon from "../../../../../components/FontIcon";
import Loading from "../../../../../components/Loading";
import Button from "../../../../../components/Button";
import { EDUCATION_TYPES } from "../../../constants/types";

const useStyles = makeStyles((theme: Theme) => ({
  formRoot: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
  formControl: {
    marginBottom: theme.spacing(3),
  },
  addBranchButton: {
    marginRight: theme.spacing(3),
  },
  root: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
  },
}));

const SchoolForm: FC<FormRenderProps> = ({
  form,
  initialValues,
  handleSubmit,
  submitError,
  submitting,
}) => {
  const classes = useStyles();
  const [src, setSrc] = React.useState<any>(
    initialValues ? initialValues.image : null,
  );
  const countries = useMemo(
    () =>
      getData().sort((a, b) =>
        a.name > b.name ? 1 : b.name > a.name ? -1 : 0,
      ),
    [],
  );

  return (
    <form onSubmit={handleSubmit}>
      {submitError && <Typography color="error">{submitError}</Typography>}
      {submitting && <Loading />}
      <Typography component="div" className={classes.root}>
        <Typography component="div" className={classes.formControl}>
          <Field
            fullWidth
            type="text"
            name="name"
            label="Name"
            placeholder="Name"
            component={BootstrapInput}
          />
        </Typography>
        <Typography component="div" className={classes.formControl}>
          <Field
            fullWidth
            label="Country"
            options={countries}
            placeholder="Country"
            component={Autocomplete}
            name={"countryObj"}
          />
        </Typography>
        <Typography component="div" className={classes.formControl}>
          <Field
            fullWidth
            type="text"
            name="website"
            label="Website"
            placeholder="Website"
            component={BootstrapInput}
          />
        </Typography>
        <Typography component="div" className={classes.formControl}>
          <div>
            <label style={{ minWidth: 180 }}>
              <Button component="span" variant="outlined">
                Choose image
              </Button>
              <input
                type="file"
                value={""}
                name="image"
                accept="image/*"
                style={{ display: "none" }}
                onChange={(e) => {
                  if (e.target.files && e.target.files[0]) {
                    form.change("image", e.target.files[0]);
                    const reader = new FileReader();
                    reader.onload = function (e1) {
                      setSrc(e1.target.result);
                    };
                    reader.readAsDataURL(e.target.files[0]);
                  }
                }}
              />
            </label>
            {src && (
              <div
                style={{
                  position: "relative",
                  width: 120,
                }}
              >
                <img src={src} alt="Hello" width="120" />
                <IconButton
                  color={"delete"}
                  style={{
                    position: "absolute",
                    right: 5,
                    top: 5,
                    background: "rgba(255, 255, 255, 0.5)",
                  }}
                  onClick={async () => {
                    setSrc(null);
                    form.change("image", null);
                  }}
                >
                  <FontIcon fontSize={"small"} name={"delete"} />
                </IconButton>
              </div>
            )}
          </div>
        </Typography>
        <Typography component="div" className={classes.formControl}>
          <Field
            fullWidth
            name="type"
            label="Type"
            options={EDUCATION_TYPES}
            placeholder="Type"
            component={Autocomplete}
          />
        </Typography>

        <Typography
          align="right"
          component="div"
          className={classes.formControl}
        >
          <Button
            type="submit"
            color="secondary"
            variant="contained"
            disabled={submitting}
          >
            {initialValues && initialValues.id ? "Update" : "Save"}
          </Button>
        </Typography>
      </Typography>
    </form>
  );
};

export default SchoolForm;
